import styled from '@emotion/styled';


const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: ${props => props.gap || "4.5rem"};
  width: 100%;
`;

const Block = styled.div`
  display: flex;
  flex-direction: column;
  gap: .6rem;
`;

const TitleBlock = styled.div`
  font-weight: 600;
  text-transform: uppercase;
  font-size: 1.2rem;
  color: ${props => props.theme.colors.mildText};
`;

const InfoBlock = styled.div`
  background-color: ${props => props.theme.colors.darkBg};
  padding: 0rem .4rem;
  border-radius: 2px;
  width: fit-content;
  /* color: ${props => props.theme.colors.lightText}; */
`;

const BlockFlex = ({ display = [], TitleComponent, InfoComponent }) => {
  let Info = InfoComponent || InfoBlock;
  let Title = TitleComponent || TitleBlock;
  return (
    <Container>
      {display.map(({title, info}, index) => (
        <Block key={title}>
          <Title>{title}</Title>
          <Info>{info}</Info>
        </Block>
      ))}
    </Container>
  )
};

export default BlockFlex;
